// export const BASE_URL = "http://localhost:9876";
// export const BASE_URL = "https://casecompendium.tk";
export const BASE_URL = "https://menteezy.com";

export const GLOGIN_CLIENT_ID =
  "224914456470-pgejhjtdhge5e4v96r227er9qhgmrg7p.apps.googleusercontent.com";
